module.exports = __webpack_public_path__ + "static/vector-pic-11a0a9f5ac8e1c98c7a53fc608d154d9.png";